<template>
  <div class="contact">
    <div class="container">
      <div v-if="$route.meta.showThankYouMessage" class="thank-you-message text-center">
        <div class="thank-you-icon">
          <i class="fas fa-check-circle"></i>
        </div>
        <h1>Vielen <span class="text-gradient">Dank</span>!</h1>
        <p class="lead">
          Ihre Nachricht wurde erfolgreich gesendet. Wir werden uns so schnell wie möglich bei Ihnen melden.
        </p>
        <router-link to="/" class="btn-back-home">
          <i class="fas fa-arrow-left"></i> Zurück zur Startseite
        </router-link>
      </div>

      <div v-else class="contact-header text-center">
        <h1>Kontaktieren Sie <span class="text-gradient">uns</span></h1>
        <p class="lead">
          Wir freuen uns darauf, von Ihnen zu hören und besprechen gerne Ihre Anforderungen für ein maßgeschneidertes Lösungskonzept.
        </p>
      </div>

      <div v-if="!$route.meta.showThankYouMessage" class="contact-content">
        <div class="row">
          <div class="col-lg-6">
            <div class="contact-info">
              <h2>Kontaktdaten</h2>
              <div class="info-item">
                <i class="fas fa-envelope"></i>
                <div>
                  <h3>E-Mail</h3>
                  <p><a href="mailto:contact@jenstrompler.de">contact@jenstrompler.de</a></p>
                </div>
              </div>
              <div class="info-item">
                <i class="fas fa-map-marker-alt"></i>
                <div>
                  <h3>Standort</h3>
                  <p>Deutschland</p>
                </div>
              </div>
              <div class="contact-cta">
                <p>Nutzen Sie unser Formular für eine schnelle Kontaktaufnahme - es öffnet direkt Ihr E-Mail-Programm:</p>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="contact-form">
              <h2>Nachricht senden</h2>
              <form @submit.prevent="directEmailSubmit" ref="contactForm">
                <!-- Direktes E-Mail-Formular ohne externe Abhängigkeiten -->
                
                <div class="form-group">
                  <label for="name">Name</label>
                  <input 
                    type="text" 
                    id="name" 
                    name="name"
                    v-model="formData.name" 
                    class="form-control" 
                    required
                  >
                </div>
                <div class="form-group">
                  <label for="email">E-Mail</label>
                  <input 
                    type="email" 
                    id="email" 
                    name="email"
                    v-model="formData.email" 
                    class="form-control" 
                    required
                  >
                </div>
                <div class="form-group">
                  <label for="subject">Betreff</label>
                  <select 
                    id="subject" 
                    name="subject"
                    v-model="formData.subject" 
                    class="form-control" 
                    required
                  >
                    <option value="" disabled selected>Bitte wählen...</option>
                    <option value="Kontaktaufnahme DevOps">Kontaktaufnahme DevOps</option>
                    <option value="Kontaktaufnahme KI">Kontaktaufnahme KI</option>
                    <option value="Sonstiges">Sonstiges</option>
                  </select>
                </div>
                <div class="form-group">
                  <label for="message">Ihre Nachricht</label>
                  <textarea 
                    id="message" 
                    name="message"
                    v-model="formData.message" 
                    class="form-control" 
                    rows="5" 
                    required
                  ></textarea>
                </div>

                <div class="form-group form-checkbox">
                  <input 
                    type="checkbox" 
                    id="privacy" 
                    v-model="formData.privacy" 
                    required
                  >
                  <label for="privacy">
                    Ich stimme zu, dass meine Daten zur Bearbeitung meiner Anfrage gespeichert werden. 
                    Weitere Informationen finden Sie in unserer <router-link to="/impressum">Datenschutzerklärung</router-link>.
                  </label>
                </div>

                <div v-if="formStatus.message" :class="['form-alert', formStatus.isError ? 'error' : 'success']">
                  {{ formStatus.message }}
                </div>

                <button 
                  type="submit" 
                  class="btn-submit" 
                  :disabled="formStatus.submitting"
                >
                  <span v-if="!formStatus.submitting">Nachricht senden</span>
                  <span v-else>Wird gesendet...</span>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppContact',
  data() {
    return {
      formData: {
        name: '',
        email: '',
        subject: '',
        message: '',
        privacy: false
      },
      formStatus: {
        submitting: false,
        message: '',
        isError: false
      }
    };
  },
  methods: {
    resetForm() {
      this.formData = {
        name: '',
        email: '',
        subject: '',
        message: '',
        privacy: false
      };
    },
    submitForm() {
      this.formStatus.submitting = true;
      this.formStatus.message = '';

      // Überprüfen, ob das Formular vollständig ausgefüllt ist
      if (!this.formData.name || !this.formData.email || !this.formData.subject || !this.formData.message || !this.formData.privacy) {
        this.formStatus.submitting = false;
        this.formStatus.isError = true;
        this.formStatus.message = "Bitte füllen Sie alle Pflichtfelder aus.";
        return;
      }

      // Kurze Verzögerung, um die Lade-Animation zu zeigen
      setTimeout(() => {
        // Feedback anzeigen
        this.formStatus.submitting = false;
        this.formStatus.isError = false;
        this.formStatus.message = "Vielen Dank für Ihre Nachricht! Wir werden uns so schnell wie möglich bei Ihnen melden.";
        this.resetForm();
        
        // Nach 2 Sekunden zur Danke-Seite umleiten
        setTimeout(() => {
          this.$router.push('/danke');
        }, 2000);
      }, 500);
    },
    
    directEmailSubmit() {
      this.formStatus.submitting = true;
      this.formStatus.message = '';

      // Überprüfen, ob das Formular vollständig ausgefüllt ist
      if (!this.formData.name || !this.formData.email || !this.formData.subject || !this.formData.message || !this.formData.privacy) {
        this.formStatus.submitting = false;
        this.formStatus.isError = true;
        this.formStatus.message = "Bitte füllen Sie alle Pflichtfelder aus.";
        return;
      }

      // E-Mail-Link erstellen
      const subject = encodeURIComponent(this.formData.subject);
      const body = encodeURIComponent(
        `Name: ${this.formData.name}\n` +
        `E-Mail: ${this.formData.email}\n\n` +
        `Nachricht:\n${this.formData.message}`
      );
      
      // E-Mail-Link öffnen
      window.location.href = `mailto:contact@jenstrompler.de?subject=${subject}&body=${body}`;
      
      // Status aktualisieren
      setTimeout(() => {
        this.formStatus.submitting = false;
        this.formStatus.isError = false;
        this.formStatus.message = "E-Mail-Programm wurde geöffnet. Falls nicht, kopieren Sie bitte unsere E-Mail-Adresse und kontaktieren Sie uns direkt.";
      }, 500);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/global.scss";

.contact {
  padding: 100px 0;
  background: linear-gradient(180deg, $background-color, darken($background-color, 3%));
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 30%;
    background: linear-gradient(180deg, rgba($accent-color, 0.05), transparent);
    z-index: 0;
  }
}

.container {
  position: relative;
  z-index: 1;
}

.contact-header {
  margin-bottom: 60px;
  
  h1 {
    font-size: 3rem;
    margin-bottom: 1rem;
    font-weight: 700;
  }
  
  .lead {
    font-size: 1.3rem;
    max-width: 700px;
    margin: 0 auto;
    color: $muted-text-color;
  }
}

.thank-you-message {
  padding: 60px 0;
  max-width: 700px;
  margin: 0 auto;
  
  .thank-you-icon {
    margin-bottom: 30px;
    
    i {
      font-size: 5rem;
      color: #28a745;
      animation: pulse 2s ease-in-out;
    }
  }
  
  h1 {
    font-size: 3.5rem;
    margin-bottom: 1.5rem;
    font-weight: 700;
  }
  
  .lead {
    font-size: 1.3rem;
    margin-bottom: 40px;
    color: $muted-text-color;
  }
  
  .btn-back-home {
    display: inline-flex;
    align-items: center;
    background: $accent-gradient;
    color: white;
    font-weight: 600;
    font-size: 1rem;
    padding: 12px 25px;
    border-radius: 30px;
    text-decoration: none;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba($accent-color, 0.3);
    
    i {
      margin-right: 10px;
    }
    
    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 8px 20px rgba($accent-color, 0.4);
    }
  }
}

@keyframes pulse {
  0% {
    transform: scale(0.8);
    opacity: 0;
  }
  50% {
    transform: scale(1.2);
    opacity: 1;
  }
  100% {
    transform: scale(1);
  }
}

.contact-content {
  .row {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -15px;
  }
  
  .col-lg-6 {
    width: calc(50% - 30px);
    margin: 0 15px;
    
    @media (max-width: 992px) {
      width: 100%;
      margin-bottom: 40px;
    }
  }
}

.contact-info {
  background: rgba($secondary-color, 0.3);
  border-radius: 15px;
  padding: 40px;
  height: 100%;
  backdrop-filter: blur(5px);
  border: 1px solid rgba($accent-color, 0.1);
  
  h2 {
    font-size: 1.8rem;
    margin-bottom: 30px;
    color: $heading-color;
    position: relative;
    
    &::after {
      content: '';
      display: block;
      width: 50px;
      height: 4px;
      background: $accent-gradient;
      margin-top: 10px;
      border-radius: 2px;
    }
  }
  
  .info-item {
    display: flex;
    margin-bottom: 25px;
    
    i {
      font-size: 1.5rem;
      color: $accent-color;
      margin-right: 20px;
      margin-top: 5px;
    }
    
    h3 {
      font-size: 1.2rem;
      margin-bottom: 5px;
      color: $heading-color;
    }
    
    p {
      margin: 0;
      color: $text-color;
      
      a {
        color: $accent-color;
        text-decoration: none;
        transition: all 0.3s ease;
        
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
  
  .contact-cta {
    margin-top: 40px;
    padding-top: 20px;
    border-top: 1px solid rgba($accent-color, 0.1);
    
    p {
      color: $muted-text-color;
      font-style: italic;
    }
  }
}

.contact-form {
  background: rgba($secondary-color, 0.3);
  border-radius: 15px;
  padding: 40px;
  backdrop-filter: blur(5px);
  border: 1px solid rgba($accent-color, 0.1);
  
  h2 {
    font-size: 1.8rem;
    margin-bottom: 30px;
    color: $heading-color;
    position: relative;
    
    &::after {
      content: '';
      display: block;
      width: 50px;
      height: 4px;
      background: $accent-gradient;
      margin-top: 10px;
      border-radius: 2px;
    }
  }
  
  .form-group {
    margin-bottom: 20px;
    
    label {
      display: block;
      margin-bottom: 8px;
      font-weight: 500;
      color: $heading-color;
    }
    
    .form-control {
      width: 100%;
      padding: 12px 15px;
      background: rgba($background-color, 0.5);
      border: 1px solid rgba($accent-color, 0.2);
      border-radius: 8px;
      color: $text-color;
      font-size: 1rem;
      transition: all 0.3s ease;
      
      &:focus {
        outline: none;
        border-color: $accent-color;
        box-shadow: 0 0 0 3px rgba($accent-color, 0.1);
      }
    }
    
    textarea.form-control {
      resize: vertical;
      min-height: 120px;
    }
    
    &.form-checkbox {
      display: flex;
      align-items: flex-start;
      
      input {
        margin-top: 5px;
        margin-right: 10px;
      }
      
      label {
        font-size: 0.9rem;
        font-weight: normal;
        color: $muted-text-color;
        
        a {
          color: $accent-color;
          text-decoration: none;
          
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
  
  .form-alert {
    margin: 20px 0;
    padding: 12px 15px;
    border-radius: 8px;
    
    &.success {
      background: rgba(#28a745, 0.1);
      border: 1px solid rgba(#28a745, 0.3);
      color: #28a745;
    }
    
    &.error {
      background: rgba(#dc3545, 0.1);
      border: 1px solid rgba(#dc3545, 0.3);
      color: #dc3545;
    }
  }
  
  .btn-submit {
    display: inline-block;
    background: $accent-gradient;
    color: white;
    font-weight: 600;
    font-size: 1rem;
    padding: 12px 30px;
    border: none;
    border-radius: 30px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba($accent-color, 0.3);
    
    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 8px 20px rgba($accent-color, 0.4);
    }
    
    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
      transform: none;
    }
  }
}

/* Responsive Styles */
@media (max-width: 768px) {
  .contact {
    padding: 70px 0;
  }
  
  .contact-header {
    h1 {
      font-size: 2.5rem;
    }
  }
  
  .contact-form, .contact-info {
    padding: 30px;
  }
}
</style>
